import { Button, Col, Row, Tag, Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Asset, MotionType, Scene, SceneAssetItem } from '@monorepo/types';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import TransitionSelector from './transition-selector/transition-selector';
import MotionModal, { MotionModalActions } from './motions/motion-modal';
import { motionDisplayText } from '@monorepo/remotion-ninja';
import { useVideoContext } from '../../../../../../../hooks/use-video';
import SceneImage from '../../../../scene-image/scene-image';

import './edit-asset.scss';

export type EditSceneForm = Pick<SceneAssetItem, 'transition'>;

const EditAsset = () => {
  const { t } = useTranslation();
  const motionModalRef = useRef<MotionModalActions>(null);
  const form = useForm<EditSceneForm>();
  const {
    updateSceneItem,
    selectedScene: scene,
    getSceneStartFrame,
    selectedSceneItemIndex,
    assets,
    modalRef,
    setSceneId,
  } = useVideoContext();

  const item = scene?.items[selectedSceneItemIndex];
  const assetData = item?.data as SceneAssetItem;

  const resetForm = () => {
    form.reset({
      transition: assetData.transition,
    });
  };

  useEffect(() => {
    resetForm();
  }, [scene?._id]);

  useEffect(() => {
    const { unsubscribe } = form.watch(async (value) => {
      const isChanged = assetData?.transition !== form.getValues('transition');

      if (scene && isChanged) {
        await updateSceneItem({
          sceneId: scene._id,
          videoId: scene.videoId,
          updateDto: {
            data: value,
          },
          itemIndex: selectedSceneItemIndex,
        });
      }
    });
    return () => unsubscribe();
  }, [form.watch()]);

  const handleOpenMotionModal = () => {
    if (!scene) {
      return;
    }

    motionModalRef.current?.open(scene);
  };

  if (!scene) {
    return null;
  }

  const sceneAsset = assets.find((asset) => asset._id === assetData.assetId);

  return (
    <Row className={'edit-asset'} gutter={[10, 15]}>
      <MotionModal ref={motionModalRef} />

      {/*<Col span={24}>*/}
      {/*  <Tag>Duration: {scene.duration.toFixed(2)}s</Tag>*/}
      {/*</Col>*/}
      <Col span={8}>
        <div>
          <SceneImage
            scene={scene}
            asset={sceneAsset}
            onAssetClick={() => {
              modalRef.current?.open({
                asset: sceneAsset ? sceneAsset : null,
                assetIndex: selectedSceneItemIndex,
              });

              setSceneId(scene?._id);
            }}
          />
          <Typography.Text style={{ fontSize: '12px' }} type={'secondary'}>
            {t('videoEditor.editAsset.clickToEdit')}
          </Typography.Text>
        </div>
      </Col>
      <Col span={16}>
        <Col span={24} style={{ marginBottom: '15px' }}>
          <Typography.Text type={'secondary'}>
            {t('videoEditor.editAsset.effectLabel')}{' '}
            <b>{motionDisplayText[assetData?.motion as MotionType]}</b>
            <br />
          </Typography.Text>
          <Tooltip
            placement={'right'}
            title={t('videoEditor.editAsset.motionTooltip')}
          >
            <Button onClick={handleOpenMotionModal}>
              {t('videoEditor.editAsset.updateMotion')}
            </Button>
          </Tooltip>
        </Col>
        <Col span={24}>
          <Typography.Title
            style={{ margin: 0, marginBottom: '5px' }}
            level={5}
          >
            {t('videoEditor.editAsset.transitionTitle')}
          </Typography.Title>
          <TransitionSelector form={form} />
        </Col>
      </Col>
    </Row>
  );
};

export default EditAsset;
